import styled from '@emotion/styled';
import * as _ from 'lodash';
import * as React from 'react';
import { useEffect, useState } from 'react';

export interface StatusWidgetProps {}

export enum Status {
  OPERATIONAL = 'operational',
  DEGRADED_PERF = 'degraded_performance',
  PARTIAL_OUTAGE = 'partial_outage',
  MAJOR_OUTAGE = 'major_outage'
}

export const STATUS = {
  [Status.OPERATIONAL]: {
    label: 'Operational',
    color: 'green'
  },
  [Status.DEGRADED_PERF]: {
    label: 'Degraded performance',
    color: 'orange'
  },
  [Status.PARTIAL_OUTAGE]: {
    label: 'Partial outage',
    color: 'orange'
  },
  [Status.MAJOR_OUTAGE]: {
    label: 'Major outage',
    color: 'red'
  }
};

export const StatusWidget: React.FC<StatusWidgetProps> = (props) => {
  const [status, setStatus] = useState<Status>(null);

  useEffect(() => {
    // @ts-ignore
    var sp = new StatusPage.page({ page: 'hh7t4xtgfyxg' });
    sp.summary({
      success: function (data) {
        const groups = _.groupBy(data.components, (c) => c.status);
        Object.keys(groups);
        setStatus(
          Object.values(Status)
            .reverse()
            .find((s) => Object.keys(groups).indexOf(s) !== -1)
        );
      }
    });
  });

  return (
    <S.Container>
      <S.Meta>Status</S.Meta>
      <S.Bottom>
        <S.Label>{STATUS[status]?.label || 'Loading...'}</S.Label>
        <S.Icon color={STATUS[status]?.color || 'transparent'} />
      </S.Bottom>
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div`
    display: flex;
    flex-direction: column;
    text-decoration: none;
    color: ${(p) => p.theme.header.textColor};
  `;

  export const Meta = styled.div`
    font-size: 12px;
    opacity: 0.5;
    text-decoration: none;
  `;

  export const Bottom = styled.div`
    display: flex;
    flex-direction: row;
    column-gap: 10px;
    align-items: center;
  `;
  export const Label = styled.div`
    font-size: 10px;
    text-decoration: none;
  `;
  export const Icon = styled.div<{ color: string }>`
    height: 10px;
    aspect-ratio: 1/ 1;
    border-radius: 5px;
    background: ${(p) => p.color};
  `;
}
